import { FC } from "react";

export const SkyFlagRewardDialog: FC = ({ }) => {

  return <>
    <div className="w-full sm:w-[800px] text-primary">
      <div className="block sm:flex mb-2">
        <div className="sm:min-w-[500px] text-center mt-auto mb-auto pb-8 px-8">
          <img src="/images/reward.jpg" className="w-[200px] inline"></img>
          <div className="text-2xl mt-4 font-bold text-[#0909FF]">クレジットが追加されました</div>
          <div className="mt-4 text-sm text-gray-500">
            タスクチャレンジの獲得条件クリアにより、クレジットが追加されました！
          </div>
          <div className="mt-4 text-sm text-gray-500">
            引き続きDrop AIでの画像生成をお楽しみください
          </div>
          <div className="mt-8 text-sm text-gray-500">
            ※マイページでのクレジット反映にタイムラグが生じる場合がございます。
          </div>
        </div>
        <div className={`relative max-h-[200px] sm:max-h-[600px] w-full`}>
          <img src="/images/login-left-image.png" className="object-cover w-full h-[160px] sm:h-[460px] object-top"></img>
          <div className="absolute left-0 right-0 bottom-0 h-[200px] sm:h-[400px] w-full" style={{ background : 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 1) 150%)' }}></div>
        </div>
        
      </div>
    </div>
  </>;

}